<template>
  <transition name="modal" v-if="addUser">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="cancel">
        <div class="modal-container">
          <div class="modal-header">
            <h3>Add User</h3>
            <div class="danger" v-if="errors.length > 0">
              <ul>
                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
              </ul>
            </div>
          </div>
          <div class="modal-body form-horizontal">
            <section>
              <h4>Common Fields</h4>
              <br>
              <div class="form-group">
                <label for="username" class="control-label col-sm-3">Username</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="username"
                    class="form-control admin-form-control"
                    type="text" name="username"
                    v-model="userFields.username"
                    placeholder="Username">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="password" class="control-label col-sm-3">Password</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="password"
                    v-model.trim="userFields.password"
                    type="password"
                    class="form-control admin-form-control"
                    placeholder="Password">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="firstName" class="control-label col-sm-3">First Name</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="firstName"
                    v-model.trim="userFields.firstName"
                    type="text"
                    class="form-control admin-form-control"
                    placeholder="First Name">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="lastName" class="control-label col-sm-3">Last Name</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="lastName"
                    v-model.trim="userFields.lastName"
                    type="text"
                    class="form-control admin-form-control"
                    placeholder="Last Name">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="email" class="control-label col-sm-3">Email</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="email"
                    v-model.trim="userFields.email"
                    type="email"
                    class="form-control admin-form-control"
                    placeholder="Email">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="address" class="control-label col-sm-3">Address</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="address"
                    v-model.trim="userFields.address"
                    type="text"
                    class="form-control admin-form-control"
                    placeholder="Address">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="city" class="control-label col-sm-3">City</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="city"
                    v-model.trim="userFields.city"
                    type="text"
                    class="form-control admin-form-control"
                    placeholder="City">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="state" class="control-label col-sm-3">State</label>
                <div class="col-sm-9 input-group">
                  <select
                    id="state"
                    v-model="userFields.state"
                    class="form-control admin-form-control">
                    <option :value="'' || undefined" disabled selected>States</option>
                    <option
                      v-for="(state, index) in states" :key="index"
                      :value="state">
                      {{ state }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="zip" class="control-label col-sm-3">Zip</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="zip"
                    v-model.trim="userFields.zip"
                    type="text"
                    class="form-control admin-form-control"
                    placeholder="Zip">
                </div>
              </div>
              <div class="clearfix"></div>
              <br>
              <div class="checkbox-option">
                <label>
                  <input
                    v-model="userFields.adminOnly"
                    type="checkbox"
                    name=""> Admin Use Only? <br>
                </label>
              </div>
              <div class="clearfix"></div>
            </section>
            <section v-if="form.length > 0">
              <h4>Program Unique Fields</h4>
              <br>
              <public-form
                :form="form"
                :completedForm="completedForm"
                ></public-form>
            </section>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" @click="cancel">Cancel</button>
            <button class="btn admin-btn-primary" @click="save">Save</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import PublicForm from '../../../components/admin/addUserModal/PublicForm'
export default {
  name: 'AddUserModal',
  props: ['addUser'],
  components: {
    'public-form': PublicForm
  },
  data () {
    return {
      userFields: {},
      completedForm: {},
      errors: [],
      fieldMap: {
        address: 'Address',
        state: 'State',
        city: 'City',
        zip: 'Zip',
        email: 'Email',
        firstName: 'First Name',
        lastName: 'Last Name'
      },
      states: [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'District of Columbia',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
      ]
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', [ 'programId' ]),
    ...mapState('loyaltyProgram', {
      program: state => state.program,
      form: state => state.program.registrationForm.formItems
    })
  },
  methods: {
    ...mapMutations('loyaltyProgram', {
      setProgram: 'SET_PROGRAM',
      updateProgram: 'UPDATE_PROGRAM'
    }),
    ...mapActions('auth', [
      'register'
    ]),
    ...mapActions('loyaltyProgram', [
      'getLoyaltyProgramBySlug'
    ]),
    getFormattedError (errorMsg) {
      const castRegex = /Cast to \w* failed for value "\w*" at path "\w*"/g
      if (errorMsg.match(castRegex)) {
        const fieldType = errorMsg.split(' ')[2].toLowerCase()
        const field = errorMsg.split(' ')[9]
        return `Expected ${field} to be a ${fieldType}`
      } else {
        return errorMsg
      }
    },
    save () {
      this.$bus.emit('global-load', { load: true, message: 'Registering user', env: 'admin' })
      this.register({
        user: this.userFields,
        loyaltyProgramId: this.programId,
        form: this.completedForm,
        approved: true,
        companyName: this.program.company ? this.program.company.name || '' : '',
        slug: this.program.slug
      })
        .then(response => {
          return this.getLoyaltyProgramBySlug(this.programId)
        })
        .then(program => {
          this.$bus.emit('global-load', { load: false })
          this.$emit('close')
        })
        .catch(e => {
          const data = e.response.data
          this.$bus.emit('global-load', { load: false })
          console.log(e)
          if (data.msg === 'Failed to create user') {
            const respErr = data.err.error
            if (respErr.errors) {
              const msgs = Object.keys(respErr.errors).reduce((msgsArr, key) => {
                msgsArr.push(this.getFormattedError(respErr.errors[key].message.replace(key, this.fieldMap[key])))
                return msgsArr
              }, [])
              this.errors = msgs
            } else if (respErr.code === 11000) {
              const msg = `An account with the username "${respErr.errmsg.split('\"')[1]}" already exists`
              this.errors = [msg]
            }
          } else {
            console.log(e.response)
            if (data.msg) {
              this.errors = [ data.msg ]
            } else {
              this.errors = [ 'There has been an error creating this user. Please contact the server admin with the attempted fields.' ]
            }
          }
        })
    },
    cancel () {
      this.userFields = {}
      this.completedForm = {}
      this.errors = []
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.danger {
  color: #af0000;
}

.modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity .6s;
}
.modal-enter, .modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
